import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconPackageAdd"><Path d="M12.25 20.25H6.75C5.09315 20.25 3.75 18.9069 3.75 17.25V6.75C3.75 5.09315 5.09315 3.75 6.75 3.75H8.75M8.75 3.75H15.25M8.75 3.75V8.25C8.75 8.80228 9.19772 9.25 9.75 9.25H14.25C14.8023 9.25 15.25 8.80228 15.25 8.25V3.75M15.25 3.75H17.25C18.9069 3.75 20.25 5.09315 20.25 6.75V11.25M18.25 14.25V17.25M18.25 17.25V20.25M18.25 17.25H15.25M18.25 17.25H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconPackageAdd;
